<template>
  <dara-icon-action-content-layout>
    <template #icon>
      <dara-user-badge :badge="user.badge" offset-y="5" offset-x="-2" />
      <dara-user-link :id="user.id">
        <dara-avatar size="lg" :source="user.profile_pic" />
      </dara-user-link>
    </template>
    <template #main>
      <dara-user-link :id="user.id">
        <dara-p v-truncate weight="strong" margin="sm">
          {{ user.name }}
          <span v-if="isSameUser(user)">({{ $t('you') }})</span>
        </dara-p>
      </dara-user-link>
      <dara-small v-truncate="2">{{ user.position }}</dara-small>
    </template>
    <template #action>
      <dara-button
        v-if="isFollowButtonVisible(user) && canFollow"
        size="xs"
        :plain="true"
        @click="onFollowButtonClick">
        {{ following ? $t('unfollow') : $t('follow') }}
      </dara-button>
    </template>
  </dara-icon-action-content-layout>
</template>

<script>
import * as userStore from '@/modules/user/user.store';
import { toastError } from '@/services/toastService';
import { getFollowingStatus, followUser, unfollowUser } from '@/modules/user/user.service';
import { translate } from '@/services/translate.service';

import DaraUserBadge from '@/modules/user/components/UserBadge.vue';
import DaraIconActionContentLayout from '@/layouts/IconActionContentLayout.vue';
import DaraUserLink from '@/modules/user/components/UserLink.vue';

export default {
  name: 'DaraUserResume',
  components: {
    DaraUserBadge,
    DaraIconActionContentLayout,
    DaraUserLink,
  },
  props: {
    user: Object,
    canFollow: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: true,
      following: false,
    };
  },
  computed: {
    currentUser() {
      return userStore.getters.getUser();
    },
    followButtonText() {
      return this.following ? 'Unfollow' : 'Follow';
    },
  },
  mounted() {
    this.getFollowingStatus();
  },
  methods: {
    getFollowingStatus() {
      this.loading = true;
      getFollowingStatus(this.user)
        .then(response => {
          this.following = response;
        })
        .catch(() => toastError(`${translate('error-getting-the-following-status')}`))
        .finally(() => {
          this.loading = false;
        });
    },
    onFollowButtonClick() {
      return this.following ? this.onUnfollowUser() : this.onFollowUser();
    },
    onFollowUser() {
      followUser(this.user)
        .then(() => {
          this.$emit('reloadUser', this.user);
        })
        .catch(() => toastError(`${translate('error-on-following-user')}`));
    },
    onUnfollowUser() {
      unfollowUser(this.user)
        .then(() => {
          this.$emit('reloadUser', this.user);
        })
        .catch(() => toastError(`${translate('error-on-unfollowing-user')}`));
    },
    isSameUser(user) {
      return this.currentUser.id === user.id;
    },
    isFollowButtonVisible(user) {
      return !this.loading && !this.isSameUser(user);
    },
  },
};
</script>
